import React from 'react';
import { cn } from '../../lib/utils';
import { Package, Users, Building2, UserCircle } from 'lucide-react';

const tabs = [
  { id: 'items', label: 'ნივთები', icon: Package },
  { id: 'clients', label: 'კლიენტები', icon: Users },
  { id: 'companies', label: 'კომპანიები', icon: Building2 },
  { id: 'accounts', label: 'აქაუნთები', icon: UserCircle }
];

export default function BottomNav({ activeTab, onTabChange }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden">
      <div className="glass border-t border-white/20 shadow-2xl">
        <div className="pb-safe">
          <div className="flex justify-around items-center h-16">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              
              return (
                <button
                  key={tab.id}
                  onClick={() => onTabChange(tab.id)}
                  className={cn(
                    'flex-1 flex flex-col items-center justify-center h-full relative transition-all duration-200',
                    'min-w-[48px] touch-manipulation'
                  )}
                  style={isActive ? { color: '#f43f5e' } : {}}
                  aria-label={tab.label}
                >
                  <div className={cn(
                    'relative flex flex-col items-center justify-center',
                    isActive ? 'text-pink-500' : 'text-gray-400 dark:text-gray-500'
                  )}>
                    <Icon className={cn(
                      'h-6 w-6 mb-1 transition-transform duration-200',
                      isActive ? 'scale-110' : ''
                    )} />
                    <span className={cn(
                      'text-[10px] font-medium transition-all',
                      isActive ? 'text-pink-500' : 'text-gray-400 dark:text-gray-500'
                    )}>
                      {tab.label}
                    </span>
                    
                    {isActive && (
                      <div className="absolute -bottom-1 w-1.5 h-1.5 bg-pink-500 rounded-full animate-pulse" />
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
}